import ScrollReveal from 'scrollreveal';

// if you're using a bundler, first import:
import Headroom from 'headroom.js';

(() => {
  document.addEventListener('DOMContentLoaded', function() {
    // grab an element
    var myElement = document.querySelector('header');
    // construct an instance of Headroom, passing the element
    var headroom = new Headroom(myElement, { offset: '90' });
    // initialise
    headroom.init({});

    let slideUp = {
      viewFactor: 0.3,
      distance: '15%',
      origin: 'bottom',
      opacity: 0,
      delay: 100,
      mobile: false,
    };
    ScrollReveal().reveal('.home__card .card__content', slideUp);

    let slideUpInteriorContent = {
      viewFactor: 0.3,
      distance: '15%',
      origin: 'bottom',
      opacity: 0,
      delay: 100,
      mobile: false,
    };
    ScrollReveal().reveal('.interior__content__wrapper', slideUpInteriorContent);

    let slideUpMyth = {
      viewFactor: 0.3,
      distance: '15%',
      origin: 'bottom',
      opacity: 0,
      delay: 200,
      mobile: false,
    };
    ScrollReveal().reveal('.myth__block .myth', slideUpMyth);

    let slideUpFact = {
      viewFactor: 0.3,
      distance: '15%',
      origin: 'bottom',
      opacity: 0,
      delay: 400,
      mobile: false,
    };
    ScrollReveal().reveal('.myth__block .fact', slideUpFact);

    let slideUpRecycleImage = {
      viewFactor: 0.3,
      distance: '15%',
      origin: 'bottom',
      opacity: 0,
      delay: 200,
      mobile: false,
    };
    ScrollReveal().reveal(
      '.recycle__block:nth-child(odd) div:nth-child(1), .recycle__block:nth-child(even) div:nth-child(2)',
      slideUpRecycleImage,
    );

    let slideUpRecycleFact = {
      viewFactor: 0.3,
      distance: '15%',
      origin: 'bottom',
      opacity: 0,
      delay: 400,
      mobile: false,
    };
    ScrollReveal().reveal(
      '.recycle__block:nth-child(even) div:nth-child(1), .recycle__block:nth-child(odd) div:nth-child(2)',
      slideUpRecycleFact,
    );

    // init();
  });
})();
